export const leaveSuccess = {
  holidaySuccess: "Company holiday created.",
  leaveRequest:"Leave request received! You'll get a notification when it's approved.",
  leavePermission: "Permission request submitted!",
  deletedLeaveRequest: "Leave request deleted.",
  checkInOutTime: "Check in/out time updated.",
  breakInOutTime: "Break start/end time updated.",
};

export const projectSuccess = {
  editProject: "Project updated.",
  cloneProject: "Project cloned.",
  createTime: "Time added.",
  updateTime: "Time updated.",
  deleteTime: "Time removed.",
  addClient: "Client added.",
  projectCreation: "Project created.",
  taskCreation: "Task created.",
  moveSprint:
    "Task moved to another sprint. Please try to complete the current sprint.",
  sprintStart: "Sprint started.",
  sprintCreation: "Sprint created.",
  sprintUpdate: "Sprint updated.",
  completeSprint: "Sprint completed.",
  taskMaterial: "Task materials added.",
  createLabel: "Label created.",
};
